export default "__VITE_ASSET__CDJawtwg__"